import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { InputSubmitModule } from '../input-submit/input-submit.module';
import { AlertMessagesModalComponent } from 'src/app/layout/components/alert-messages-modal/alert-messages-modal.component';
import { AlertModule } from '../alert/alert.module';

@NgModule({
  declarations: [ModalComponent, AlertMessagesModalComponent],
  imports: [CommonModule, InputSubmitModule, SharedModule, AlertModule],
  exports: [ModalComponent, AlertMessagesModalComponent]
})
export class ModalModule {}
